export default "__VITE_ASSET__DmKMFbIV__"